/**
 * @generated SignedSource<<584c8042492809d5fe360eef7c136d8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ExpenseCategory = "CONSULTING_AND_ADMINISTRATION" | "HARDWARE_AND_EQUIPMENT" | "INFRASTRUCTURE" | "INSURANCE" | "MEMBERSHIPS_AND_DONATIONS" | "OTHER" | "SERVICES_AND_LICENSES" | "TRAVEL" | "VEHICLES" | "%future added value";
export type ServicePeriodStatus = "CONFIRMED" | "PROPOSED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type IncomingInvoicesView_invoices$data = {
  readonly expenseInvoices: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly currency: string;
        readonly deletedInFastBillAt: any | null | undefined;
        readonly expenseCategory: ExpenseCategory | null | undefined;
        readonly expenseCategoryOverride: ExpenseCategory | null | undefined;
        readonly hasDocument: boolean;
        readonly id: string;
        readonly invoiceDate: any;
        readonly invoiceNumber: string | null | undefined;
        readonly netAmount: number;
        readonly netAmountInEuro: number;
        readonly netAmountInServiceMonth: number | null | undefined;
        readonly paidDate: any | null | undefined;
        readonly servicePeriodEnd: any | null | undefined;
        readonly servicePeriodStart: any | null | undefined;
        readonly servicePeriodStatus: ServicePeriodStatus | null | undefined;
        readonly supplierName: string;
      };
    }>;
    readonly totalCount: number;
  };
  readonly " $fragmentType": "IncomingInvoicesView_invoices";
};
export type IncomingInvoicesView_invoices$key = {
  readonly " $data"?: IncomingInvoicesView_invoices$data;
  readonly " $fragmentSpreads": FragmentRefs<"IncomingInvoicesView_invoices">;
};

import IncomingInvoicesPaginationQuery_graphql from './IncomingInvoicesPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "expenseInvoices"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filter"
    },
    {
      "defaultValue": 100,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": IncomingInvoicesPaginationQuery_graphql
    }
  },
  "name": "IncomingInvoicesView_invoices",
  "selections": [
    {
      "alias": "expenseInvoices",
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "filter"
        }
      ],
      "concreteType": "ExpenseInvoiceConnection",
      "kind": "LinkedField",
      "name": "__IncomingInvoicesView_expenseInvoices_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ExpenseInvoiceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ExpenseInvoice",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supplierName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "invoiceNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "invoiceDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "servicePeriodStart",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "servicePeriodEnd",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "servicePeriodStatus",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expenseCategory",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expenseCategoryOverride",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "netAmountInEuro",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "netAmountInServiceMonth",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currency",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "netAmount",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "paidDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasDocument",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "deletedInFastBillAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "66afba5aaaef10d5e525ce5db24866b5";

export default node;
